export const USER_TOKEN_KEY = "userToken";
export const USER_EMAIL = "currentUserEmail";
export const TWILIO_USER_TOKEN_KEY = "twilioUserToken";
export const LANDBOT_TOKEN = "@landbot/core/storage";
export const REFRESH_TOKEN_KEY = "refresh_token";
export const REMEMBER_EMAIL_KEY = "remember_email";
export const REMEMBER_FLAG_KEY = "remember_flag";
